import { defaultClient } from '@mint-sdk/api-core';

import { usersTagsResponseSchema } from './schemas.js';

// Labels for the User Management table are loaded separately from the user rows so the grid does not wait on the MDM lookup.
export const usersTagsQueryOptions = defaultClient.query({
  url: 'bff/v2/brands_and_geo/users_tags' as const,
  method: 'GET',
  responseSchema: usersTagsResponseSchema,
  processResponse(data) {
    return data;
  },
});
